import React from 'react'
import ContactTable from '../TableOfContacts/TableOfContacts'

const ContactForFollowUp = (props) => {
  const { divisionId, userId, statusId, followUpReport, otherFilters } = props
  return (
    <>
      <ContactTable
        isShowActions={false}
        {...props}
        isFollowUp={followUpReport}
        initialFilter={{
          'divisions.division_id': divisionId,
          'divisions.status_id': statusId,
          'divisions.assigned': userId,
          follow_up_report: followUpReport,
          ...otherFilters,
        }}
      />
    </>
  )
}

export default ContactForFollowUp
